import _sortBy from 'lodash/sortBy';

/**
 * @param chargebeePlanSettings - result of calling getChargebeePlanSettings query
 * @param quarterlyRunRate - result of calling getCustomerQrr query
 * @returns the cheapest plan that is not a free trial and has enough royalty capacity to cover the
 * quarterly run rate
 */
export const getCheapestPlan = (
    chargebeePlanSettings: ChargebeePlanSettings[] | null,
    quarterlyRunRate: Maybe<number>,
): ChargebeePlanSettings | null => {
    if (chargebeePlanSettings === null || quarterlyRunRate === null) {
        return null;
    }

    const chargebeePlanSettingsSortedByBaseCost = _sortBy(
        chargebeePlanSettings,
        'BASE_COST',
    );

    const cheapest = chargebeePlanSettingsSortedByBaseCost.find(
        ({ id, ROYALTY_DOLLARS_INCLUDED }: ChargebeePlanSettings): boolean =>
            id !== 'CHARGEBEE_PLAN_TRIAL' &&
            ROYALTY_DOLLARS_INCLUDED !== null &&
            ROYALTY_DOLLARS_INCLUDED !== undefined &&
            ROYALTY_DOLLARS_INCLUDED > quarterlyRunRate,
    );

    return cheapest ?? null;
};
